export var mapToMultiResendInviteRequest = function (payload, isInviteExpirationEnabled) {
    return payload.map(function (user) {
        if (isInviteExpirationEnabled) {
            return {
                userId: user.userId,
            };
        }
        return {
            userId: user.userId,
            email: user.email,
        };
    });
};
export var mapPaymentCardToViewModel = function (paymentCards, businessName) {
    return paymentCards.map(function (card) {
        return {
            actions: card.actions || {},
            addedBy: card.addedBy || '',
            authorizeFlag: card.authorizeFlag || false,
            cardBrand: (card === null || card === void 0 ? void 0 : card.cardBrand) || '',
            cardBrandType: card.cardBrandType || '',
            cardNumberLast4: card.cardNumberLast4 || '',
            createdDate: card.createdDate || 0,
            hasValidationErrors: card.hasValidationErrors || false,
            isDefault: card.isDefault || false,
            lastModifiedDate: card.lastModifiedDate || 0,
            locBuyerId: card.locBuyerId || '',
            locType: card.locType,
            locName: card.locType === 'SHOP' ? businessName || '' : card.locName || '',
            paymentId: card.paymentId,
            paymentType: card.paymentType,
            perkTypeStatus: card.perkTypeStatus,
            t2cPrimary: card.t2cPrimary || false,
            trackingOnly: card.trackingOnly || '',
        };
    });
};
